import { DESTINATION, DESTINATION_TYPE } from '@adtrackify/at-tracking-event-types';

import { useDestinationByType } from './use-destination-by-type';

export function useDestinationConnected(
  destination: DESTINATION | string,
  destinationType: DESTINATION_TYPE
): boolean {
  const dest = useDestinationByType(destination, destinationType);
  return dest?.enabled ?? false;
}

export function useFacebookIntegrationConnected(): boolean {
  return useDestinationConnected('facebookIntegration', DESTINATION_TYPE.INTEGRATION);
}

export function useGoogleIntegrationConnected(): boolean {
  return useDestinationConnected('googleAdsIntegration', DESTINATION_TYPE.INTEGRATION);
}

export function useShopifyIntegrationConnected(): boolean {
  return useDestinationConnected('shopifyIntegration', DESTINATION_TYPE.INTEGRATION);
}
